var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diff-version-header"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.version)+" version")]),(_vm.subtitle != '')?_c('div',{attrs:{"role":"doc-subtitle"}},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e()]),(_vm.$slots.tag)?_vm._t("tag"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }